import { Checkbox, Popover } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useContextReports } from '../../../../../../../context/reports';
import { useEnableComparisonDisplayUpdate } from '../../../../../../../hooks/reports';

const ComparisonDisplayCheckbox = () => {
  const { fetch: updateEnableComparisonDisplay, loading: isLoading } = useEnableComparisonDisplayUpdate()
  const { report, reportId, setReport } = useContextReports();

  const toggleComparisonDisplay = async (event: CheckboxChangeEvent) => {
    const isChecked = event.target.checked;

    await updateEnableComparisonDisplay({ enableComparisonDisplay: isChecked }, reportId);

    if (report) {
      setReport?.({...report, enableComparisonDisplay: isChecked });
    }
  }

  return (
    <Popover content="Turn on high/low calculation">
      <Checkbox
        checked={report?.enableComparisonDisplay}
        onChange={toggleComparisonDisplay}
        disabled={isLoading}
      />
    </Popover>
  )
}

export default ComparisonDisplayCheckbox;
